import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {actions} from '../../actions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const RUBRICS_HEADER_ROW = ["Criteria", "Ratings"];

const stylesCard = theme => ({
    card: {
        padding: 0,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginLeft: '5px',
        marginRight: '5px',
        height: "100%"
    },
    cardActionArea: {
        height: "100%",
        padding: 0
    },
    cardContent: {
        padding: 0
    },
    cardSelected: {
        backgroundColor: "#CCC"
    },
    cardDefault: {
        backgroundColor: "#FFF"
    },
});

class RadioCard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {rating, classes, selected} = this.props;
        const selectionClass = classes.cardDefault;
        if(rating.na){
            return (
                <Card className={classNames([classes.card, selectionClass])}>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="subtitle1" gutterBottom>
                            {rating.rating_title}
                        </Typography>
                        <Typography variant="body3">
                            {rating.rating_description}
                        </Typography>
                        <Typography variant="subtitle2">
                            Pts: N/A
                        </Typography>
                    </CardContent>
                </Card>
            );
        } else {
            return (
                <Card className={classNames([classes.card, selectionClass])}>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="subtitle1" gutterBottom>
                            {rating.rating_title}
                        </Typography>
                        <Typography variant="body3">
                            {rating.rating_description}
                        </Typography>
                        <Typography variant="subtitle2">
                            Points: {rating.points}
                        </Typography>
                    </CardContent>
                </Card>
            );
        }

    }
}

const RadioCardWithStyles = withStyles(stylesCard)(RadioCard);

const stylesRubricRate = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        flexGrow: 1
    },
    table: {
        // minWidth: 700,
        // tableLayout: 'auto'
        // padding: "none"
    },
    cell: {
        // width: "auto"
        padding: theme.spacing.unit
    },
    grid: {
        padding: 0
    },
    button: {
        margin: theme.spacing.unit,
    }
});

class AssessmentRubricDisplay extends Component {
    renderHeaderRow = () => (
        <TableRow>
            {RUBRICS_HEADER_ROW.map(item => (
                    <TableCell align="center" className={this.props.classes.cell}>
                        <Typography variant="subtitle1">{item}</Typography>
                    </TableCell>
                )
            )}
        </TableRow>
    );

    renderRubricRows = (rubrics) => {
        return rubrics.map((rubric, rubricIndex) => {
            const mappedCells = rubric.ratings.map((rating, ratingIndex) => {
                return (
                    <Grid item xs className={this.props.classes.grid}>
                        <RadioCardWithStyles rating={rating} rubricIndex={ratingIndex} />
                    </Grid>
                );
            });

            return (
                <TableRow key={rubricIndex}>
                    <TableCell component="th" scope="row" align="center" className={this.props.classes.cell}>
                        <Typography variant="subtitle1" gutterBottom>
                            {rubric.criteria_title}
                        </Typography>
                    </TableCell>
                    <TableCell align="center" className={this.props.classes.cell}>
                        <Grid container spacing={24}>{mappedCells}</Grid>
                    </TableCell>

                </TableRow>
            );
        });
    };

    render() {
        return (
            <Paper className={this.props.classes.root}>
                <Table className={this.props.classes.table}>
                    <TableHead>
                        {this.renderHeaderRow()}
                    </TableHead>
                    <TableBody>
                        {this.renderRubricRows(this.props.rubrics)}
                    </TableBody>
                </Table>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return {
        reviewers: state.reviewers,
        user: state.user,
        rubrics: state.rubrics,
        form: state.newAssessmentForm
    }
}

export default connect(mapStateToProps, actions)(withStyles(stylesRubricRate)(AssessmentRubricDisplay));
